import store from '@/store/store'
import { capitalizeFirstLetter } from '@/utils/helpers/StringOperations'
import { DataLoader } from '@/utils/helpers/DataLoader/DataLoader'
import { payload as seriesActionPayload } from '@/components/RouteComponents/Series/actionPayload'
import { payload as setActionPayload } from '@/components/RouteComponents/Sets/actionPayload'
import { payload as locationActionPayload } from '@/components/RouteComponents/Locations/actionPayload'
import { payload as freefieldActionPayload } from '@/components/RouteComponents/Freefields/actionPayload'
import { payload as taxcodeActionPayload } from '@/components/RouteComponents/Taxcodes/actionPayload'
import { payload as insurancecodeActionPayload } from '@/components/RouteComponents/Insurances/actionPayload'
import { payload as sourcecodeActionPayload } from '@/components/RouteComponents/Sourcecodes/actionPayload'

export async function getPoLinesToRelieve (trxId, type) {
  const lines = store.getters[`get${capitalizeFirstLetter(type)}LinesByTransactionId`](trxId)
  let poLineIds = Object.values(lines).filter(line => line.relieves).map(line => line.relieves)
  let lineAccounts = Object.values(lines).filter(line => line.account).map(line => line.account)
  let thirdPartyVendorsIds = Object.values(lines).filter(line => line.third_party_vendor).map(line => line.third_party_vendor)

  if (!poLineIds.length && !lineAccounts.length && !thirdPartyVendorsIds.length) {
    return {}
  }
  let promises = []
  if (poLineIds.length) {
    if (poLineIds.length > 500) {
      for (let i = 0; i < poLineIds.length; i += 500) {
        const chunk = [...new Set(poLineIds.slice(i, i + 500))]
        promises.push(store.dispatch('fetchPoLinesWithQuery', { id__in: chunk, page_size: chunk.length }))
      }
    } else promises.push(store.dispatch('fetchPoLinesWithQuery', { id__in: [...new Set(poLineIds)], page_size: poLineIds.length }))
  }
  if (lineAccounts.length) {
    if (lineAccounts.length > 100) {
      for (let i = 0; i < lineAccounts.length; i += 100) {
        const acchunk = [...new Set(lineAccounts.slice(i, i + 100))]
        promises.push(store.dispatch('fetchAccountsWithQuery', { id__in: acchunk, page_size: acchunk.length }))
      }
    } else promises.push(store.dispatch('fetchAccountsWithQuery', { id__in: [...new Set(lineAccounts)], page_size: lineAccounts.length }))
  }
  if (thirdPartyVendorsIds.length) {
    promises.push(store.dispatch('fetchVendorsWithQuery', { id__in: [...new Set(thirdPartyVendorsIds)], page_size: thirdPartyVendorsIds.length }))
  }
  return await Promise.all(promises)
}

export async function getOffsetDcJeLines (trxId, type) {
  let offsetResponse = Object.values(store.getters[`get${capitalizeFirstLetter(type)}LinesByTransactionId`](trxId))
    .filter(v => v.offset_by)
    .map(v => store.getters.getJeLineById(v.offset_by))
  if (offsetResponse && offsetResponse.length) {
    // const offsetResponse = await Promise.all(offsetPromises)
    let jes = []
    offsetResponse.forEach(line => jes.push(line.transaction_id))
    jes = [...new Set(jes)]
    jes.map(id => {
      const jeLines = Object.values(store.getters.getJeLinesByTransactionId(id))
      store.dispatch('findDependencies', {lines: jeLines})
    })
  }
}

export async function loadInitialData () {
  let payloads = []
  const {
    getAllSets,
    getAllSeries,
    getAllTaxcodes,
    getAllLocations,
    getAllFreefields,
    getAllInsurances,
    getAllSourcecodes
  } = store.getters

  if (!getAllSets.length) {
    payloads.push(setActionPayload)
  }
  if (!getAllLocations.length) {
    payloads.push(locationActionPayload)
  }
  if (!getAllSeries.length) {
    payloads.push(seriesActionPayload)
  }
  if (!getAllFreefields.length) {
    payloads.push(freefieldActionPayload)
  }
  if (!getAllTaxcodes.length) {
    payloads.push(taxcodeActionPayload)
  }
  if (!getAllInsurances.length) {
    payloads.push(insurancecodeActionPayload)
  }
  if (!getAllSourcecodes.length || !getAllSourcecodes.length <= 2) {
    payloads.push(sourcecodeActionPayload)
  }
  let dataLoader = new DataLoader(store, payloads, true, 200)
  await dataLoader.loadDataBeforeRoute()
  // let promises = []
  // promises.push(store.dispatch('fetchSetsWithQuery', { page_size: 200 }))
  // promises.push(store.dispatch('fetchSeriesWithQuery', { page_size: 200 }))
  // promises.push(store.dispatch('fetchTaxcodesWithQuery', { page_size: 200 }))
  // promises.push(store.dispatch('fetchLocationsWithQuery', { page_size: 200 }))
  // promises.push(store.dispatch('fetchFreefieldsWithQuery', { page_size: 200 }))
  // return await Promise.all(promises)
}
